import Header, { HeaderLeft } from "../../../layout/Header/Header";
import CommonHeaderRight from "./CommonHeaderRight";

const AccountReceiptsHeader = () => {
  return (
    <Header>
      <HeaderLeft>
        <div>
          <div className="fw-bold fs-6 mb-0">Account Receipts</div>
          <div className="text-muted">
            <small>
                All money received by the Flat.
            </small>
          </div>
        </div>
      </HeaderLeft>
      <CommonHeaderRight />
    </Header>
  );
};

export default AccountReceiptsHeader;
